'use strict';
/**
 * Spray encountered a problem with a message.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExMessage =
/**
   * @param {string} source The name of the function that threw.
   * @param {object} message The incriminated message.
   * @param {string} reason The reason of the throw.
   */
function ExMessage(source, message, reason) {
  _classCallCheck(this, ExMessage);

  this.source = source;
  this.message = message;
  this.reason = reason;
};

module.exports = ExMessage;